import { css } from '@/styled-system/css';

export const pageRootStyles = css.raw({
  display: 'flow-root',
  background: 'Page.bg',
  paddingBlockEnd: 'layout.vast.default',
});
